// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   Dashboard styling (scoped with the dash- prefix, under .dash-page).
   Builds on the existing .tmis-stat / .tmis-table-responsive classes (kept
   for their mobile card layout) and the app-wide accent tokens
   (.accent-blue/violet/teal/green/magenta in App.css), so each color is
   defined once and adapts to dark mode.
   ========================================================================== */

.dash-page {
  --dash-muted: #475569;
  --dash-line: rgba(148, 163, 184, 0.28);
}
.dark-theme.dash-page {
  --dash-muted: rgba(255, 255, 255, 0.72);
  --dash-line: rgba(255, 255, 255, 0.12);
}

/* ---------- motion ---------- */
/* slide only: fading text in makes it momentarily fail contrast checks */
@keyframes dash-fade-up {
  from { transform: translateY(10px); }
  to   { transform: none; }
}
@keyframes dash-pulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.55); }
  50%      { box-shadow: 0 0 0 5px rgba(34, 197, 94, 0); }
}
.dash-fade { animation: dash-fade-up 0.45s ease both; animation-delay: var(--d, 0ms); }

@media (prefers-reduced-motion: reduce) {
  .dash-fade, .dash-live-dot { animation: none !important; }
  .dash-page .tmis-stat { transition: none !important; }
}

/* ---------- hero ---------- */
.dash-hero {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  padding: 24px 28px;
  border-radius: 20px;
  color: #fff;
  background: linear-gradient(120deg, #1a3483 0%, #2d52c4 55%, #6d3fae 100%);
  box-shadow: 0 18px 40px rgba(26, 52, 131, 0.28);
}
.dark-theme .dash-hero {
  background: linear-gradient(120deg, #13224f 0%, #1f3a8a 55%, #4c2a85 100%);
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.45);
}
.dash-hero::before,
.dash-hero::after {
  content: "";
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
}
.dash-hero::before {
  width: 260px; height: 260px;
  right: -60px; top: -110px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.22), transparent 70%);
}
.dash-hero::after {
  width: 200px; height: 200px;
  right: 24%; bottom: -120px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.14), transparent 70%);
}
.dash-hero-text, .dash-clock { position: relative; z-index: 1; }

.dash-hero-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 12.5px;
  font-weight: 700;
  background: rgba(6, 14, 40, 0.34);
  border: 1px solid rgba(255, 255, 255, 0.28);
}
.dash-hero-title {
  margin: 10px 0 4px;
  font-size: 30px;
  font-weight: 800;
  letter-spacing: -0.4px;
  color: #fff;
}
.dash-hero-sub { margin: 0; color: #ffffff; font-size: 14.5px; }
.dash-hero-stats { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 14px; }
.dash-hero-stat {
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 12.5px;
  font-weight: 600;
  background: rgba(6, 14, 40, 0.38);
}
.dash-hero-stat b { font-weight: 850; margin-right: 3px; }

.dash-clock {
  min-width: 160px;
  padding: 12px 16px;
  border-radius: 16px;
  text-align: right;
  background: rgba(6, 14, 40, 0.34);
  border: 1px solid rgba(255, 255, 255, 0.28);
  backdrop-filter: blur(4px);
}
.dash-clock-date { font-size: 12.5px; font-weight: 700; color: #ffffff; }
.dash-clock-time { font-size: 26px; font-weight: 850; letter-spacing: 0.5px; color: #fff; line-height: 1.15; }

/* ---------- stat cards (builds on .tmis-stat) ---------- */
.dash-page .tmis-stat { border-radius: 18px; box-shadow: 0 12px 30px rgba(15, 23, 42, 0.07); }
.dash-page .tmis-stat:hover { box-shadow: 0 18px 38px rgba(15, 23, 42, 0.12); }
.dark-theme .dash-page .tmis-stat,
.dark-theme.dash-page .tmis-stat {
  background: #2a2b2c;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-top: 4px solid var(--tmis-accent-dark);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.35);
}
.dash-page .tmis-stat-top { gap: 10px; }
.dash-stat-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 34px; height: 34px;
  border-radius: 10px;
  font-size: 17px;
  background: var(--tmis-accent-tint);
  color: var(--tmis-accent);
}
.dark-theme .dash-stat-icon {
  background: rgba(255, 255, 255, 0.1);
  background: color-mix(in srgb, var(--tmis-accent-dark) 14%, transparent);
  color: var(--tmis-accent-dark-text, var(--tmis-accent-dark));
}

/* ---------- section head ---------- */
.dash-section-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 6px;
}
.dash-section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 800;
  color: #0f172a;
}
.dark-theme .dash-section-title { color: #fff; }
.dash-title-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px; height: 32px;
  border-radius: 10px;
  font-size: 15px;
  background: #e6ebf8;
  color: #1a3483;
}
.dark-theme .dash-title-icon { background: rgba(57, 135, 229, 0.2); color: #7fb0f5; }

.dash-refreshed {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
  font-size: 13px;
  color: var(--dash-muted);
}
.dash-refreshed strong { color: #0f172a; }
.dark-theme .dash-refreshed strong { color: #fff; }
.dash-live-dot {
  width: 8px; height: 8px;
  border-radius: 50%;
  background: #22c55e;
  animation: dash-pulse 2s ease-in-out infinite;
}
.dark-theme .dash-page .tmis-enq-badge,
.dark-theme.dash-page .tmis-enq-badge {
  color: #86efac;
  background: rgba(34, 197, 94, 0.14);
  border-color: rgba(34, 197, 94, 0.35);
}

/* ---------- table ---------- */
.dash-page .tmis-tablecard {
  border-radius: 18px;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.07);
}
.dark-theme .dash-page .tmis-tablecard.dark,
.dark-theme.dash-page .tmis-tablecard.dark {
  background: #212529;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.35);
}
.dash-table thead th {
  font-size: 12px !important;
  font-weight: 800;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: var(--dash-muted);
  border-bottom-width: 2px;
  white-space: nowrap;
}
.dash-table td { vertical-align: middle; }
.dash-table tbody tr { transition: background 0.15s ease; }
.dash-person { display: flex; align-items: center; gap: 10px; min-width: 0; }
.dash-person-name { font-weight: 700; line-height: 1.25; }
.dash-date { font-weight: 700; white-space: nowrap; }
.dash-time { font-size: 12px; color: var(--dash-muted); white-space: nowrap; }
/* Long free text shouldn't push the Source/Status columns off-screen:
   cap these two and show an ellipsis (the full value stays in the title). */
.dash-page .dash-table td.tmis-ellipsis { max-width: 130px; }
.dash-page .dash-table td[data-label="Email"] {
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@media (max-width: 767px) {
  /* mobile card layout shows every field in full */
  .dash-page .dash-table td.tmis-ellipsis,
  .dash-page .dash-table td[data-label="Email"] { max-width: none; white-space: normal; }
}
.dash-page .tmis-pill { padding: 5px 12px; box-shadow: 0 2px 6px rgba(15, 23, 42, 0.12); }

/* ---------- activities panel ---------- */
.dash-page .tmis-activities { border-radius: 18px; box-shadow: 0 12px 30px rgba(15, 23, 42, 0.07); }
.dark-theme .dash-page .tmis-activities.dark,
.dark-theme.dash-page .tmis-activities.dark {
  background: #212529;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.35);
}
.dash-activities-head {
  position: sticky;
  top: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 14px 16px;
  background: linear-gradient(120deg, rgba(26, 52, 131, 0.08), rgba(109, 63, 174, 0.08)), #fff;
  border-bottom: 1px solid var(--dash-line);
}
.dark-theme .dash-activities-head {
  background: linear-gradient(120deg, rgba(57, 135, 229, 0.16), rgba(124, 58, 237, 0.16)), #212529;
}
.dash-activities-title { display: flex; align-items: center; gap: 10px; font-size: 17px; font-weight: 800; }
.dash-activities-head .tmis-compact-select { width: auto; min-width: 92px; }

.dash-date-sep {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 6px 2px 10px;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: var(--dash-muted);
}
.dash-date-sep::after { content: ""; flex: 1 1; height: 1px; background: var(--dash-line); }

.dash-activity {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 10px;
  padding: 12px;
  border-radius: 14px;
  border: 1px solid var(--dash-line);
  border-left: 4px solid var(--src, #94a3b8);
  background: rgba(248, 250, 252, 0.7);
  transition: transform 0.15s ease, background 0.15s ease;
}
.dash-activity:hover { transform: translateX(2px); background: rgba(26, 52, 131, 0.05); }
.dark-theme .dash-activity { background: rgba(255, 255, 255, 0.05); }
.dark-theme .dash-activity:hover { background: rgba(255, 255, 255, 0.09); }
.dash-activity-main { flex: 1 1; min-width: 0; }
.dash-activity-top { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
.dash-activity-name { font-weight: 800; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.dash-activity-check { flex-shrink: 0; font-size: 15px; color: #0d602d; }
.dark-theme .dash-activity-check { color: #4ade80; }
.dash-activity-course,
.dash-activity-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 3px;
  font-size: 12.5px;
  color: var(--dash-muted);
}
.dash-activity-course span,
.dash-activity-meta span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

/* ---------- phones ---------- */
@media (max-width: 767px) {
  .dash-hero { padding: 20px; }
  .dash-hero-title { font-size: 24px; }
  .dash-clock { width: 100%; text-align: left; }
  /* the mobile table-card layout already labels every field; keep the name row tidy */
  .dash-page .tmis-table-responsive td[data-label="Name"] .dash-person { justify-content: flex-end; }
  .dash-page .tmis-table-responsive td .dash-time { display: inline; margin-left: 6px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboard.css"],"names":[],"mappings":"AAAA;;;;;;+EAM+E;;AAE/E;EACE,qBAAqB;EACrB,sCAAsC;AACxC;AACA;EACE,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA,iCAAiC;AACjC,yEAAyE;AACzE;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,eAAe,EAAE;AAC1B;AACA;EACE,WAAW,2CAA2C,EAAE;EACxD,WAAW,0CAA0C,EAAE;AACzD;AACA,aAAa,uCAAuC,EAAE,8BAA8B,EAAE;;AAEtF;EACE,6BAA6B,0BAA0B,EAAE;EACzD,wBAAwB,2BAA2B,EAAE;AACvD;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,0EAA0E;EAC1E,+CAA+C;AACjD;AACA;EACE,0EAA0E;EAC1E,2CAA2C;AAC7C;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,YAAY,EAAE,aAAa;EAC3B,YAAY,EAAE,WAAW;EACzB,+EAA+E;AACjF;AACA;EACE,YAAY,EAAE,aAAa;EAC3B,UAAU,EAAE,cAAc;EAC1B,+EAA+E;AACjF;AACA,+BAA+B,kBAAkB,EAAE,UAAU,EAAE;;AAE/D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,2CAA2C;AAC7C;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;AACb;AACA,iBAAiB,SAAS,EAAE,cAAc,EAAE,iBAAiB,EAAE;AAC/D,mBAAmB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AAC/E;EACE,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;AACnC;AACA,oBAAoB,gBAAgB,EAAE,iBAAiB,EAAE;;AAEzD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,iCAAiC;EACjC,2CAA2C;EAC3C,0BAA0B;AAC5B;AACA,mBAAmB,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACxE,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,WAAW,EAAE,iBAAiB,EAAE;;AAE7G,4DAA4D;AAC5D,wBAAwB,mBAAmB,EAAE,8CAA8C,EAAE;AAC7F,8BAA8B,8CAA8C,EAAE;AAC9E;;EAEE,mBAAmB;EACnB,2CAA2C;EAC3C,6CAA6C;EAC7C,2CAA2C;AAC7C;AACA,4BAA4B,SAAS,EAAE;AACvC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW,EAAE,YAAY;EACzB,mBAAmB;EACnB,eAAe;EACf,mCAAmC;EACnC,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,wEAAwE;EACxE,4DAA4D;AAC9D;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA,kCAAkC,WAAW,EAAE;AAC/C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW,EAAE,YAAY;EACzB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;AACA,+BAA+B,mCAAmC,EAAE,cAAc,EAAE;;AAEpF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,wBAAwB;AAC1B;AACA,yBAAyB,cAAc,EAAE;AACzC,qCAAqC,WAAW,EAAE;AAClD;EACE,UAAU,EAAE,WAAW;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;AAC/C;AACA;;EAEE,cAAc;EACd,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,8CAA8C;AAChD;AACA;;EAEE,mBAAmB;EACnB,2CAA2C;EAC3C,2CAA2C;AAC7C;AACA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;AACrB;AACA,iBAAiB,sBAAsB,EAAE;AACzC,uBAAuB,iCAAiC,EAAE;AAC1D,eAAe,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,YAAY,EAAE;AAC5E,oBAAoB,gBAAgB,EAAE,iBAAiB,EAAE;AACzD,aAAa,gBAAgB,EAAE,mBAAmB,EAAE;AACpD,aAAa,eAAe,EAAE,wBAAwB,EAAE,mBAAmB,EAAE;AAC7E;4EAC4E;AAC5E,0CAA0C,gBAAgB,EAAE;AAC5D;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iDAAiD;EACjD;kDACgD,eAAe,EAAE,mBAAmB,EAAE;AACxF;AACA,wBAAwB,iBAAiB,EAAE,4CAA4C,EAAE;;AAEzF,2CAA2C;AAC3C,8BAA8B,mBAAmB,EAAE,8CAA8C,EAAE;AACnG;;EAEE,mBAAmB;EACnB,2CAA2C;EAC3C,2CAA2C;AAC7C;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,4FAA4F;EAC5F,yCAAyC;AAC3C;AACA;EACE,gGAAgG;AAClG;AACA,yBAAyB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC3G,6CAA6C,WAAW,EAAE,eAAe,EAAE;;AAE3E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA,wBAAwB,WAAW,EAAE,SAAO,EAAE,WAAW,EAAE,4BAA4B,EAAE;;AAEzF;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,0CAA0C;EAC1C,oCAAoC;EACpC,uDAAuD;AACzD;AACA,uBAAuB,0BAA0B,EAAE,mCAAmC,EAAE;AACxF,6BAA6B,qCAAqC,EAAE;AACpE,mCAAmC,qCAAqC,EAAE;AAC1E,sBAAsB,SAAO,EAAE,YAAY,EAAE;AAC7C,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,QAAQ,EAAE;AACnG,sBAAsB,gBAAgB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACxG,uBAAuB,cAAc,EAAE,eAAe,EAAE,cAAc,EAAE;AACxE,mCAAmC,cAAc,EAAE;AACnD;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;2BAC2B,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;;AAE3F,iCAAiC;AACjC;EACE,aAAa,aAAa,EAAE;EAC5B,mBAAmB,eAAe,EAAE;EACpC,cAAc,WAAW,EAAE,gBAAgB,EAAE;EAC7C,oFAAoF;EACpF,uEAAuE,yBAAyB,EAAE;EAClG,kDAAkD,eAAe,EAAE,gBAAgB,EAAE;AACvF","sourcesContent":["/* ==========================================================================\n   Dashboard styling (scoped with the dash- prefix, under .dash-page).\n   Builds on the existing .tmis-stat / .tmis-table-responsive classes (kept\n   for their mobile card layout) and the app-wide accent tokens\n   (.accent-blue/violet/teal/green/magenta in App.css), so each color is\n   defined once and adapts to dark mode.\n   ========================================================================== */\n\n.dash-page {\n  --dash-muted: #475569;\n  --dash-line: rgba(148, 163, 184, 0.28);\n}\n.dark-theme.dash-page {\n  --dash-muted: rgba(255, 255, 255, 0.72);\n  --dash-line: rgba(255, 255, 255, 0.12);\n}\n\n/* ---------- motion ---------- */\n/* slide only: fading text in makes it momentarily fail contrast checks */\n@keyframes dash-fade-up {\n  from { transform: translateY(10px); }\n  to   { transform: none; }\n}\n@keyframes dash-pulse {\n  0%, 100% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.55); }\n  50%      { box-shadow: 0 0 0 5px rgba(34, 197, 94, 0); }\n}\n.dash-fade { animation: dash-fade-up 0.45s ease both; animation-delay: var(--d, 0ms); }\n\n@media (prefers-reduced-motion: reduce) {\n  .dash-fade, .dash-live-dot { animation: none !important; }\n  .dash-page .tmis-stat { transition: none !important; }\n}\n\n/* ---------- hero ---------- */\n.dash-hero {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 16px;\n  padding: 24px 28px;\n  border-radius: 20px;\n  color: #fff;\n  background: linear-gradient(120deg, #1a3483 0%, #2d52c4 55%, #6d3fae 100%);\n  box-shadow: 0 18px 40px rgba(26, 52, 131, 0.28);\n}\n.dark-theme .dash-hero {\n  background: linear-gradient(120deg, #13224f 0%, #1f3a8a 55%, #4c2a85 100%);\n  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.45);\n}\n.dash-hero::before,\n.dash-hero::after {\n  content: \"\";\n  position: absolute;\n  border-radius: 50%;\n  pointer-events: none;\n}\n.dash-hero::before {\n  width: 260px; height: 260px;\n  right: -60px; top: -110px;\n  background: radial-gradient(circle, rgba(255, 255, 255, 0.22), transparent 70%);\n}\n.dash-hero::after {\n  width: 200px; height: 200px;\n  right: 24%; bottom: -120px;\n  background: radial-gradient(circle, rgba(255, 255, 255, 0.14), transparent 70%);\n}\n.dash-hero-text, .dash-clock { position: relative; z-index: 1; }\n\n.dash-hero-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 12px;\n  border-radius: 999px;\n  font-size: 12.5px;\n  font-weight: 700;\n  background: rgba(6, 14, 40, 0.34);\n  border: 1px solid rgba(255, 255, 255, 0.28);\n}\n.dash-hero-title {\n  margin: 10px 0 4px;\n  font-size: 30px;\n  font-weight: 800;\n  letter-spacing: -0.4px;\n  color: #fff;\n}\n.dash-hero-sub { margin: 0; color: #ffffff; font-size: 14.5px; }\n.dash-hero-stats { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 14px; }\n.dash-hero-stat {\n  padding: 4px 12px;\n  border-radius: 999px;\n  font-size: 12.5px;\n  font-weight: 600;\n  background: rgba(6, 14, 40, 0.38);\n}\n.dash-hero-stat b { font-weight: 850; margin-right: 3px; }\n\n.dash-clock {\n  min-width: 160px;\n  padding: 12px 16px;\n  border-radius: 16px;\n  text-align: right;\n  background: rgba(6, 14, 40, 0.34);\n  border: 1px solid rgba(255, 255, 255, 0.28);\n  backdrop-filter: blur(4px);\n}\n.dash-clock-date { font-size: 12.5px; font-weight: 700; color: #ffffff; }\n.dash-clock-time { font-size: 26px; font-weight: 850; letter-spacing: 0.5px; color: #fff; line-height: 1.15; }\n\n/* ---------- stat cards (builds on .tmis-stat) ---------- */\n.dash-page .tmis-stat { border-radius: 18px; box-shadow: 0 12px 30px rgba(15, 23, 42, 0.07); }\n.dash-page .tmis-stat:hover { box-shadow: 0 18px 38px rgba(15, 23, 42, 0.12); }\n.dark-theme .dash-page .tmis-stat,\n.dark-theme.dash-page .tmis-stat {\n  background: #2a2b2c;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-top: 4px solid var(--tmis-accent-dark);\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.35);\n}\n.dash-page .tmis-stat-top { gap: 10px; }\n.dash-stat-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 34px; height: 34px;\n  border-radius: 10px;\n  font-size: 17px;\n  background: var(--tmis-accent-tint);\n  color: var(--tmis-accent);\n}\n.dark-theme .dash-stat-icon {\n  background: rgba(255, 255, 255, 0.1);\n  background: color-mix(in srgb, var(--tmis-accent-dark) 14%, transparent);\n  color: var(--tmis-accent-dark-text, var(--tmis-accent-dark));\n}\n\n/* ---------- section head ---------- */\n.dash-section-head {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 6px;\n}\n.dash-section-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 18px;\n  font-weight: 800;\n  color: #0f172a;\n}\n.dark-theme .dash-section-title { color: #fff; }\n.dash-title-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px; height: 32px;\n  border-radius: 10px;\n  font-size: 15px;\n  background: #e6ebf8;\n  color: #1a3483;\n}\n.dark-theme .dash-title-icon { background: rgba(57, 135, 229, 0.2); color: #7fb0f5; }\n\n.dash-refreshed {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 4px;\n  font-size: 13px;\n  color: var(--dash-muted);\n}\n.dash-refreshed strong { color: #0f172a; }\n.dark-theme .dash-refreshed strong { color: #fff; }\n.dash-live-dot {\n  width: 8px; height: 8px;\n  border-radius: 50%;\n  background: #22c55e;\n  animation: dash-pulse 2s ease-in-out infinite;\n}\n.dark-theme .dash-page .tmis-enq-badge,\n.dark-theme.dash-page .tmis-enq-badge {\n  color: #86efac;\n  background: rgba(34, 197, 94, 0.14);\n  border-color: rgba(34, 197, 94, 0.35);\n}\n\n/* ---------- table ---------- */\n.dash-page .tmis-tablecard {\n  border-radius: 18px;\n  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.07);\n}\n.dark-theme .dash-page .tmis-tablecard.dark,\n.dark-theme.dash-page .tmis-tablecard.dark {\n  background: #212529;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.35);\n}\n.dash-table thead th {\n  font-size: 12px !important;\n  font-weight: 800;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  color: var(--dash-muted);\n  border-bottom-width: 2px;\n  white-space: nowrap;\n}\n.dash-table td { vertical-align: middle; }\n.dash-table tbody tr { transition: background 0.15s ease; }\n.dash-person { display: flex; align-items: center; gap: 10px; min-width: 0; }\n.dash-person-name { font-weight: 700; line-height: 1.25; }\n.dash-date { font-weight: 700; white-space: nowrap; }\n.dash-time { font-size: 12px; color: var(--dash-muted); white-space: nowrap; }\n/* Long free text shouldn't push the Source/Status columns off-screen:\n   cap these two and show an ellipsis (the full value stays in the title). */\n.dash-page .dash-table td.tmis-ellipsis { max-width: 130px; }\n.dash-page .dash-table td[data-label=\"Email\"] {\n  max-width: 160px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n@media (max-width: 767px) {\n  /* mobile card layout shows every field in full */\n  .dash-page .dash-table td.tmis-ellipsis,\n  .dash-page .dash-table td[data-label=\"Email\"] { max-width: none; white-space: normal; }\n}\n.dash-page .tmis-pill { padding: 5px 12px; box-shadow: 0 2px 6px rgba(15, 23, 42, 0.12); }\n\n/* ---------- activities panel ---------- */\n.dash-page .tmis-activities { border-radius: 18px; box-shadow: 0 12px 30px rgba(15, 23, 42, 0.07); }\n.dark-theme .dash-page .tmis-activities.dark,\n.dark-theme.dash-page .tmis-activities.dark {\n  background: #212529;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.35);\n}\n.dash-activities-head {\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 14px 16px;\n  background: linear-gradient(120deg, rgba(26, 52, 131, 0.08), rgba(109, 63, 174, 0.08)), #fff;\n  border-bottom: 1px solid var(--dash-line);\n}\n.dark-theme .dash-activities-head {\n  background: linear-gradient(120deg, rgba(57, 135, 229, 0.16), rgba(124, 58, 237, 0.16)), #212529;\n}\n.dash-activities-title { display: flex; align-items: center; gap: 10px; font-size: 17px; font-weight: 800; }\n.dash-activities-head .tmis-compact-select { width: auto; min-width: 92px; }\n\n.dash-date-sep {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 6px 2px 10px;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n  color: var(--dash-muted);\n}\n.dash-date-sep::after { content: \"\"; flex: 1; height: 1px; background: var(--dash-line); }\n\n.dash-activity {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 10px;\n  padding: 12px;\n  border-radius: 14px;\n  border: 1px solid var(--dash-line);\n  border-left: 4px solid var(--src, #94a3b8);\n  background: rgba(248, 250, 252, 0.7);\n  transition: transform 0.15s ease, background 0.15s ease;\n}\n.dash-activity:hover { transform: translateX(2px); background: rgba(26, 52, 131, 0.05); }\n.dark-theme .dash-activity { background: rgba(255, 255, 255, 0.05); }\n.dark-theme .dash-activity:hover { background: rgba(255, 255, 255, 0.09); }\n.dash-activity-main { flex: 1; min-width: 0; }\n.dash-activity-top { display: flex; align-items: center; justify-content: space-between; gap: 8px; }\n.dash-activity-name { font-weight: 800; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.dash-activity-check { flex-shrink: 0; font-size: 15px; color: #0d602d; }\n.dark-theme .dash-activity-check { color: #4ade80; }\n.dash-activity-course,\n.dash-activity-meta {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 3px;\n  font-size: 12.5px;\n  color: var(--dash-muted);\n}\n.dash-activity-course span,\n.dash-activity-meta span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n\n/* ---------- phones ---------- */\n@media (max-width: 767px) {\n  .dash-hero { padding: 20px; }\n  .dash-hero-title { font-size: 24px; }\n  .dash-clock { width: 100%; text-align: left; }\n  /* the mobile table-card layout already labels every field; keep the name row tidy */\n  .dash-page .tmis-table-responsive td[data-label=\"Name\"] .dash-person { justify-content: flex-end; }\n  .dash-page .tmis-table-responsive td .dash-time { display: inline; margin-left: 6px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
